export default __webpack_public_path__ + "static/media/lib-5.5599b9a4.jpg";